/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import PageFooter from "./PageFooter.jsx";

export default class PageLayout extends Component {
  componentDidMount(props) {}

  render() {
    if (this.props.isAuthentication === true) {
      return (
        <div className="app-content content">
          <div className="content-wrapper">
            <div className="content-wrapper-before"></div>
            <div className="content-header row"></div>
            <div className="content-body">{this.props.children ?? ""}</div>
          </div>
        </div>
      );
    } else {
      return (
        <>
          <div className="app-content content pb-5">
            <div className="content-wrapper">
              <div className={"content-wrapper-before " + (this.props.extendedHeader && "extended")}></div>
              {(this.props.header || this.props.breadcrumb) && ContentHeader(this.props)}
              <div className="content-body">{this.props.children ?? ""}</div>
            </div>
          </div>
          <PageFooter></PageFooter>
        </>
      );
    }
  }
}

function ContentHeader(props) {
  return (
    <div className="content-header-left row">
      <div className="col">
        <h3 className="content-header-title">{props.header}</h3>
      </div>
      <div className="col-auto text-right">
        <div className="breadcrumb-wrapper mr-1">
          <ol className="breadcrumb">
            {props.breadcrumbs &&
              props.breadcrumbs.map((breadcrumb, index) => {
                if (index < props.breadcrumbs.length - 1) {
                  return (
                    <li className="breadcrumb-item" key={index}>
                      <Link key={index} to={breadcrumb.linkTo}>
                        {breadcrumb.title}
                      </Link>
                    </li>
                  );
                } else {
                  return (
                    <li className="breadcrumb-item active" key={index}>
                      {breadcrumb.title}
                    </li>
                  );
                }
              })}
          </ol>
        </div>
      </div>
    </div>
  );
}
